import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import _ from 'lodash';
import { Paso3 } from 'src/app/global/interfaces/paso-3';
import { FlujosPaso3Service } from 'src/app/global/services/flujos-paso-3.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { AgendaServiceVM } from 'src/app/view-model/services/agenda-vm.service';
import { ValidacionEdicionServiceVM } from 'src/app/view-model/services/validacion-edicion.service';

@Component({
  selector: 'app-carrusel-agenda',
  templateUrl: './carrusel-agenda.component.html',
  styleUrls: ['./carrusel-agenda.component.scss']
})
export class CarruselAgendaComponent implements OnInit {
  @Output() agenda_OK: EventEmitter<any> = new EventEmitter();


  public fechasDespacho: any;
  semanaInicial = 0;
  arregloFechas: any;
  showToolTip = false;
  cambioFecha = false;
  showCalendario = true;
  dataPaso3: Paso3;
  diaSeleccionado = 0;
  loading = false;
  enablePrev = false;
  enableNext = true;
  esUnSoloDia = false;
  screenSize: number;
  esDespachoCourier = false;
  esInstalacionTecnico = false;

  @HostListener('window:resize', ['$event'])
  cambiaAnchura() {
    this.screenSize = window.innerWidth;
    this.verificarPantalla();
  }

  private verificarPantalla() {
    if (this.screenSize <= 768) {
      if (this.arregloFechas.length === 0) {
        this.fechasDespacho = this.valAgendaService.formatUnaFecha(this.dataPaso3.datosAgenda.data.value1);
      } else {
        this.fechasDespacho = this.arregloFechas;
      }
      this.showToolTip = false;
    } else {
      if (this.arregloFechas.length !== 0) {
        this.semanaPrevia();
      }
    }
  }


  get flujo() { return this.flujo3Service.datosAgenda; }

  constructor(private valAgendaService: AgendaServiceVM,
              private flujo3Service: FlujosPaso3Service,
              private localStorageService: LocalStorageService,
              private valEdicionService: ValidacionEdicionServiceVM,
              private tagManagerService: TagManagerService) { }


  ngOnInit() {
    this.screenSize = window.innerWidth;
    this.dataPaso3 = this.localStorageService.getPaso3();
    this.validaTipoEntrega(this.dataPaso3.datosAgenda.data.value2);
    this.arregloFechas = this.valAgendaService.formatFechas(this.dataPaso3.datosAgenda.data);
    if (this.arregloFechas.length === 0) {
      this.arregloFechas = this.valAgendaService.formatUnaFecha(this.dataPaso3.datosAgenda.data.value1);
      this.esUnSoloDia = true;
      this.showToolTip = false;
    } else {
      this.esUnSoloDia = false;
      if (this.arregloFechas[0].default) {
        this.showToolTip = true;
      } else {
        this.showToolTip = false;
      }
      this.semanaPrevia();
    }
    this.verificarPantalla();
    // this.getDatosAgenda();
  }

  validaTipoEntrega(tipoEntrega: string) {
    if (tipoEntrega == "FLUJO_COURIER"){
      this.esDespachoCourier = true;
    } else if (tipoEntrega == "FLUJO_AGENDAMIENTO") { 
      this.esInstalacionTecnico = true;
    }
  }

  semanaPrevia(): any {
    this.enableNext = true;
    if (this.semanaInicial <= 0) {
      this.semanaInicial = 0;
      this.fechasDespacho = _.slice(this.arregloFechas, this.semanaInicial, 7);
      this.diaSeleccionado = 1;
      this.enablePrev = false;
    } else {
      this.semanaInicial = this.semanaInicial - 7;
      this.fechasDespacho = _.slice(this.arregloFechas, this.semanaInicial, this.semanaInicial + 7);
      this.showToolTip = false;
      this.enablePrev = true;
    }

  }

  semanaSiguiente() {
    this.enablePrev = true;
    if (this.fechasDespacho.length < 7) {
      this.enableNext = false;
      return;
    }
    if (this.semanaInicial > this.arregloFechas.length) {
      this.enableNext = false;
      return;
    }
    this.semanaInicial = this.semanaInicial + 7;
    if (this.semanaInicial >= this.arregloFechas.length) {
      this.enableNext = false;
      this.semanaInicial = this.semanaInicial - 7;
      return;
    }
    this.fechasDespacho = _.slice(this.arregloFechas, this.semanaInicial, this.semanaInicial + 7);
    this.showToolTip = false;
  }

  changeFecha(indice: number) {
    if (this.loading) {
      return;
    }
    this.diaSeleccionado = indice;
    this.loading = true;
    this.showToolTip = false;
    this.cambioFecha = true;

    const cbOK = response => {
      this.setDefaultFalse();
      this.setToDefault(this.fechasDespacho[indice].fecha);
      this.dataPaso3.datosAgenda.data.value1 = this.fechasDespacho[indice].fecha;
      this.loading = false;
      this.tagManagerService.logDiaEntrega();
      this.dataPaso3.validaPaso3 = response;
      this.localStorageService.setPaso3(this.dataPaso3);
      this.valEdicionService.setValidaStatus(response.data);
      this.flujo3Service.datosAgenda.ok = true;
      this.flujo3Service.configuracionCuotas.cargando = true;
      this.agenda_OK.emit();
    };

    const cbError = error => {
      this.loading = false;
      console.error(error);
    };

    this.valAgendaService.postAgenda(this.fechasDespacho[indice].fecha).subscribe(cbOK, cbError);
  }

  private setDefaultFalse() {
    this.arregloFechas.forEach( fecha => fecha.default = false );
  }

  private setToDefault(fechaNueva: string) {
    this.arregloFechas.forEach( fecha => {
      if (fecha.fecha === fechaNueva) {
        fecha.default = true;
      }
    });
  }

}
